import React from 'react';
import { Section } from './Section';
const comparisonRows = [{
  sin: '3-5 hs/semana planificando desde cero',
  con: '10 min/semana. El resto es enseñar.',
  icon: '⏰'
}, {
  sin: 'Siempre los mismos ejercicios',
  con: '60+ clases distintas',
  icon: '😓'
}, {
  sin: 'Alumnos que abandonan sin saber por qué',
  con: 'Progresión → retención visible',
  icon: '💸'
}, {
  sin: 'Sin progresión clara de nivel a nivel',
  con: '6 tomos con progresión anual',
  icon: '📋'
}, {
  sin: 'Alumno con lesión = pánico',
  con: 'Cuerpo Seguro Pro → adaptación segura',
  icon: '😨'
}, {
  sin: 'Niveles mezclados = caos',
  con: 'Variaciones en 3 niveles',
  icon: '👥'
}, {
  sin: 'Sin sistema de comunicación',
  con: '18 flyers + 30 días de contenido',
  icon: '📱'
}, {
  sin: 'Sin identidad profesional visible',
  con: 'Sistema que justifica cobrar más',
  icon: '💼'
}];
export function ComparisonTable() {
  return <Section className="bg-brand-light !py-8 md:!py-12" data-id="element-46" data-mp="21z0h12g5d18s">
      <div className="text-center mb-4 md:mb-6" data-id="element-47" data-mp="2dxfeheup0e8h">
        <div className="text-brand-accent font-bold tracking-widest text-xs mb-1.5" data-id="element-48" data-mp="2dy6xlq73sjhv">
          STRETCHING 360™
        </div>
        <h2 className="text-xl md:text-3xl font-display font-black text-white mb-2 max-w-3xl mx-auto leading-tight" data-id="element-49" data-mp="29xn4cxpni010">
          El próximo lunes podés volver a improvisar la clase. O podés entrar al
          estudio con todo resuelto desde hoy.
        </h2>
        <p className="text-lg md:text-xl text-red-400 font-bold" data-id="element-50" data-mp="2wvhzlik4dr10">
          ¿Cuánto cuesta NO tenerlo?
        </p>
      </div>

      {/* Desktop table */}
      <div className="max-w-4xl mx-auto hidden md:block" data-id="element-51" data-mp="2ssvavqiqwm81">
        <table className="w-full text-left border-collapse" data-id="element-52" data-mp="36krq4tzbf1n0">
          <thead data-id="element-53" data-mp="31n9rbwf0i2sq">
            <tr data-id="element-54" data-mp="31mq6o7xz90b0">
              <th className="px-2 py-2 border-b border-white/10 w-8" data-id="element-55" data-mp="31ob0fvcgwf7t"></th>
              <th className="px-2 py-2 border-b border-white/10 text-red-400 font-display font-bold text-sm w-[45%] bg-red-500/5 rounded-tl-xl text-center" data-id="element-56" data-mp="3gjh8soz1cq4b">
                SIN STRETCHING RESUELTO
              </th>
              <th className="px-2 py-2 border-b border-white/10 text-brand-accent font-display font-bold text-sm w-[45%] bg-brand-accent/5 rounded-tr-xl text-center" data-id="element-57" data-mp="3ipfa7ggs98d0">
                CON STRETCHING RESUELTO
              </th>
            </tr>
          </thead>
          <tbody data-id="element-58" data-mp="17w2nwwhezyp">
            {comparisonRows.map((row, i) => <tr key={i} className="border-b border-white/5" data-id="element-59" data-mp="19guherew4sv" data-mpi={i}>
                <td className="px-2 py-1.5 text-base text-center" data-id="element-60" data-mp="67ieq30kqa5x">
                  {row.icon}
                </td>
                <td className="px-2 py-1.5 text-gray-400 bg-red-500/5 text-xs leading-tight text-center" data-id="element-61" data-mp="a7j2wfdh5zq6">
                  {row.sin}
                </td>
                <td className="px-2 py-1.5 text-white bg-brand-accent/5 font-medium text-xs leading-tight text-center" data-id="element-62" data-mp="f5u8uf0nfq34">
                  {row.con}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="max-w-lg mx-auto md:hidden space-y-2" data-id="element-63" data-mp="2lywjq5azflge">
        {comparisonRows.map((row, i) => <div key={i} className="rounded-lg border border-white/5 overflow-hidden" data-id="element-64" data-mp="2efdsxcvhynx9" data-mpi={i}>
            <div className="flex items-center gap-2 px-3 py-1.5 bg-white/[0.03]" data-id="element-65" data-mp="29muekdozjore">
              <span className="text-sm" data-id="element-66" data-mp="24o9eqfdnb73h">{row.icon}</span>
            </div>
            <div className="grid grid-cols-2 divide-x divide-white/5" data-id="element-67" data-mp="24mg830318mvh">
              <div className="px-2.5 py-2 bg-red-500/5" data-id="element-68" data-mp="1zriz1t5r6dil">
                <div className="text-red-400/70 text-[9px] font-bold uppercase tracking-wider mb-0.5" data-id="element-69" data-mp="2xdq2gzqblztd">
                  Sin
                </div>
                <p className="text-gray-400 text-[11px] leading-snug" data-id="element-70" data-mp="2sf53f3mt1m6i">
                  {row.sin}
                </p>
              </div>
              <div className="px-2.5 py-2 bg-brand-accent/5" data-id="element-71" data-mp="2igfq7o5uspwl">
                <div className="text-brand-accent/70 text-[9px] font-bold uppercase tracking-wider mb-0.5" data-id="element-72" data-mp="2iia44iipjhr6">
                  Con
                </div>
                <p className="text-white text-[11px] leading-snug font-medium" data-id="element-73" data-mp="170r40z0fbuwu">
                  {row.con}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
}